// Root.jsx
import React, { useState, useEffect } from "react";
import { useOidc } from "@axa-fr/react-oidc";
import { useSelector } from "react-redux";
import FreshLogin from "./components/common/freshLogin";
import { Login } from "./pages/Login/LoginPage.jsx";
import App from "./App";
import Logout from "./pages/Authentication/Logout.jsx";

const Root = () => {
    const { isAuthenticated, login } = useOidc();
    const [initDone, setInitDone] = useState(false);
    const responseError = useSelector((state) => state.auth.responseError);
    const isLogoutPath =
        window.location.pathname.replace(/\/+$/, "") === "/logout";

    // Handle initial login
    useEffect(() => {
        if (isLogoutPath) return;
        if (!isAuthenticated) {
            login(window.location.href);
        }
    }, [isAuthenticated, isLogoutPath]);

    // Handle token error -> re-login
    useEffect(() => {
        if (isLogoutPath) return;
        if (responseError) {
            login(window.location.href);
        }
    }, [responseError, isLogoutPath]);

    if (isLogoutPath) return <Logout />;
    if (!isAuthenticated) return <Login />;
    if (!initDone) return <FreshLogin onComplete={() => setInitDone(true)} />;

    return <App />;
};

export default Root;
